import { Menu } from 'antd';
import styled from 'styled-components';

import { global } from '../../../shared/colors';

const StyledAntMenu = styled(Menu)`
    width: 64px;
    margin-top: 25px;
    background: ${global.Gray6};
    margin-inline: 0;

    .ant-menu-item {
        margin: 0;
        width: 64px;
        min-height: 64px;
        border-right: none;
        padding-inline: 17px;
        border-radius: 0 6px 6px 0;

        a {
            height: 100%;

            svg {
                font-size: 30px;
            }
        }
    }

    .ant-menu-item-selected {
        margin-inline: 0;
        border-right: none;
        border-radius: 0 6px 6px 0;
        background-color: ${global.Black};

        svg {
            color: ${global.White};
        }
    }

    .ant-menu-item:hover {
        background-color: ${global.Gray4} !important;
    }
`;

export default StyledAntMenu;
